<template>
    <main class="mt-5">
        <div class="card mt-3">
            <div class="card-header border-0 justify-content-between d-flex">
                <h5 class="card-title font-bold py-3">نمایش درخواست های {{ (seller&&seller.full_name)?seller.full_name:"..." }}</h5>
                <div style="flex: 1"></div>
                <router-link :to="`/admin/sales-management/change-status/${(seller&&seller.id)?seller.id:''}?type=return&seller_name=${(seller&&seller.full_name)?seller.full_name:''}`" class="btn"
                    style="color: #fff;background-color: rgb(173 31 31 / 77%);border-color: rgb(211 215 215 / 63%);line-height: 1.1;">
                    بازگشت تنوع ها
                </router-link>
                <router-link :to="`/admin/sales-management/change-status/${(seller&&seller.id)?seller.id:''}?type=all`" class="btn mr-2"
                    style="color: #fff;background-color: #83c7b4;border-color: rgb(211 215 215 / 63%);line-height: 1.1;">
                    ارسال همه‌ی تنوع های جدید
                    <span class="bg-dot">{{ numberListItem(sellerRequests.data) }}</span>
                </router-link>
            </div>
            <div class="card-body">
                <div class="flex-row justify-content-center">
                    <table class="table table-responsive-sm table-bordered table-hover">
                        <thead style="background: rgb(192 210 225 / 42%);">
                            <tr>
                                <th>ردیف</th>
                                <th>نام تنوع</th>
                                <th>وضعیت درخواست</th>
                                <th>تاریخ دریافت درخواست</th>
                                <th>ارسال تکی</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, index) in sellerRequests.data" :style="item.status == 'pending' ? 'background: rgb(255 218 218 / 16%)' :
                                item.status == 'sold' ? 'background: rgb(227 255 218 / 28%)' : item.status == 'sent' ? 'background: rgb(240 255 255 / 19%)'
                                   : 'background: rgb(205 205 205 / 20%)' " :key="index">
                                <td>{{ index + 1 }}</td>
                                <td>{{ item.var_name }}</td>
                                <td>
                                    <span v-if="item.status == 'pending'" class="badge badge-warning status">جدید</span>
                                    <span v-else-if="item.status == 'sent'" class="badge badge-secondary status">ارسال
                                        شده</span>
                                    <span v-else-if="item.status == 'sold'" class="badge badge-success status">فروخته
                                        شده</span>
                                    <span v-else class="badge badge-danger status">برگشت داده شده</span>
                                </td>
                                <td>{{ item.created_at | persianDate }}</td>
                                <td>
                                    <router-link :to="`/admin/sales-management/change-status/${seller.id}?type=once&var_name=${item.var_name}&seller_name=${seller.full_name}`" class="btn btn-sm btn-info">
                                        ارسال
                                    </router-link>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <pagination :router="true" v-if="sellerRequests && sellerRequests.data != ''" :disabled="disabled"
                        :limit="2" :data="sellerRequests" @pagination-change-page="changePage" />
                </div>
                <Loading v-if="$root.isEmptyObject(seller)" />
            </div>
        </div>
    </main>
</template>

<script>
import SellerDetailImpl from "@@/core/pages/SalesManagement/SalesManagementSellerDetail/SellerDetailImpl";
export default {
    extends: SellerDetailImpl,
};
</script>
<style src="@@/core/pages/SalesManagement/SalesManagementSellerDetail/SellerDetailStyle.css"></style>